import React, { Component } from 'react';
import {
    CardBody,
    CardContainer,
    CardHeader,
    PlayButton,
    EmptyCardContainer,
    DarkButton,
    KebabContainer,
    CardHeaderContent,
    CardNameInput,
} from './style';
import { TruncatedText } from '../../../UI/Text';
import { Icon } from '../../../Components/Icons/Icons';
import { HoverableFadingContainer } from '../../../Components/HoverableFadingContainer';
import { GymTvCardActionsKebab } from '../../../Components/Dropdowns';
import { ConditionalOverlayWrapper } from './OverlayWrapper';

export class RoomCard extends Component {
    state = {
        name: this.props.name,
    };

    handleTitleChange = e => {
        const name = e.target.value;
        this.setState({ name }, () => this.props.onTitleChange(name, this.props.id));
    };

    render() {
        const { id, onPlay, onDuplicate, onDelete, onEdit, onInputToggle, cardSelected, background } = this.props;
        const { name } = this.state;
        return (
            <CardContainer>
                <KebabContainer>
                    <GymTvCardActionsKebab
                        onDelete={onDelete}
                        onDuplicate={onDuplicate}
                        onEdit={onEdit}
                        onPlay={onPlay}
                    />
                </KebabContainer>

                <CardHeader>
                    <CardHeaderContent>
                        {id === cardSelected.id ? (
                            <CardNameInput type={'text'} value={name} name={'name'} onChange={this.handleTitleChange} />
                        ) : (
                            <TruncatedText weight={'bold'} fontSize={22}>
                                {name && name !== '' ? name : null}
                            </TruncatedText>
                        )}
                    </CardHeaderContent>

                    <HoverableFadingContainer>
                        <Icon.Box onClick={onInputToggle} cursor={'pointer'} opacity={0.5} size={'24x24'}>
                            <Icon.Edit />
                        </Icon.Box>
                    </HoverableFadingContainer>
                </CardHeader>

                <CardBody background={background} onClick={onEdit}>
                    <PlayButton onClick={onPlay}>Play</PlayButton>
                    <ConditionalOverlayWrapper isApplied={false} />
                </CardBody>
            </CardContainer>
        );
    }
}

RoomCard.defaultProps = {
    cardSelected: {},
    onPlay: () => {},
    onDuplicate: () => {},
    onDelete: () => {},
    onEdit: () => {},
    onInputToggle: () => {},
    onNameChange: () => {},
};

export const EmptyRoomCard = ({ onAction }) => (
    <CardContainer>
        <CardHeader />
        <EmptyCardContainer>
            <DarkButton onClick={onAction}>Add</DarkButton>
        </EmptyCardContainer>
    </CardContainer>
);

EmptyRoomCard.defaultProps = {
    onAction: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/RoomCard.js